import { BookmarkDto } from "mock-api/src/managed-receiving-global/types-v2";
import { createGlobalResourceUrl, UUID } from "src/utils";

export const helpTicketBookmarkResource = createGlobalResourceUrl(
  "HelpAssistBookmarks",
);

export class TicketCountsBookmark {
  private constructor(args: ClassProperties<TicketCountsBookmark>) {
    this.autoApprovedReservationsCount = args.autoApprovedReservationsCount;
    this.openTicketsCount = args.openTicketsCount;
    this.partnerKey = args.partnerKey;
    this.siteId = args.siteId;
    this.siteName = args.siteName;
    this.totalCount = args.totalCount;
    this.unassignedTicketsCount = args.unassignedTicketsCount;
    this.yourTicketsCount = args.yourTicketsCount;
  }
  public readonly autoApprovedReservationsCount: number;
  public readonly openTicketsCount: number;
  public readonly partnerKey: UUID;
  public readonly siteId: number;
  public readonly siteName: string;
  public readonly totalCount: number;
  public readonly unassignedTicketsCount: number;
  public readonly yourTicketsCount: number;

  public static deserialize(apiModel: BookmarkDto): TicketCountsBookmark {
    return new TicketCountsBookmark({
      autoApprovedReservationsCount:
        apiModel.autoApprovedReservationsCount ?? 0,
      openTicketsCount: apiModel.openTicketsCount ?? 0,
      partnerKey: new UUID(apiModel.partnerKey),
      siteId: apiModel.siteId,
      siteName: apiModel.siteName,
      totalCount: apiModel.totalCount,
      unassignedTicketsCount: apiModel.unassignedTicketsCount ?? 0,
      yourTicketsCount: apiModel.yourTicketsCount,
    });
  }

  public static deserializeList(
    apiModel: readonly BookmarkDto[],
  ): readonly TicketCountsBookmark[] {
    return apiModel.map(TicketCountsBookmark.deserialize);
  }
}
